import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import i18n from "i18n-js";
import React, { useState } from 'react';
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import Footer from "@/components/basic/Footer";
import AvatarEdit from "@/components/media/AvatarEdit";
import avatar1 from "@/assets/images/avatar_mit_background.png"
import QRCodeView from "@/components/basic/QRCodeView";

export default function Publisher({ navigation, route }) {
    const { publisher, title } = route.params

    const [image, setImage] = useState(publisher.image?.id || avatar1)

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: '' }
    ]

    return (
        <View className="flex-1 bg-secondary-50 p-3">
            <Text className="text-2xl text-secondary-900">{i18n.t('shareQRCode.publicUser')}</Text>
            <VStack space='xl' className="flex-1 px-2 py-3 items-center">
                <AvatarEdit key={image} uri={image} selected={null} sync={'/contact/media/' + image} isEdit={false} />
                <FloatingLabelInput box='w-full px-3' label={i18n.t('contact.preferredName')} value={publisher.name} placeholder={i18n.t('contact.preferredName')} isDisabled />
                <QRCodeView data={publisher.id} title={title} width='100%' height='50%'/>
            </VStack>
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}